import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageManagerService {
    constructor() { }

    read(key: string) {
      return JSON.parse(sessionStorage.getItem('SingleSourceAngularApp_' + key));
    }
    write(key: string, value: any): void {
      sessionStorage.setItem('SingleSourceAngularApp_' + key, JSON.stringify(value));
    }

    // Delete data
    public remove(key: string) {
      sessionStorage.removeItem('SingleSourceAngularApp_' + key)
    }

    // Clear all storage
    public clearAll() {
      sessionStorage.clear();
    }
}
